import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './assets/styles.css';
import './assets/fonts.css';
import { initSession } from './services/getSessionId';
import { GoogleReCaptchaProvider } from './providers/GoogleReCaptchaProvider/GoogleReCaptchaProvider';

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

// Ensure session is initialized before rendering so api calls include the session header
(async () => {
  try {
    await initSession();
  } catch (e) {
    console.warn('Failed to initialize session', e);
  }

  createRoot(container).render(
    <React.StrictMode>
      <GoogleReCaptchaProvider>
        <App />
      </GoogleReCaptchaProvider>
    </React.StrictMode>,
  );
})();
